import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-received-sales-card',
  templateUrl: './received-sales-card.component.html',
  styleUrls: ['./received-sales-card.component.scss'],
})
export class ReceivedSalesCardComponent implements OnInit {
  public isLoaded: boolean = false;
  public sumSales: number = 0;
  public sumSalesPercent: number = 0;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.getAvailableBalanceAmount();
  }

  getAvailableBalanceAmount() {
    this.isLoaded = true;

    this.dashBoardService
      .getSalesSum()
      .then((value) => {
        this.sumSales = value.currentValue;
        this.sumSalesPercent = value.percentLastPeriod;
      })
      .finally(() => {
        this.isLoaded = false;
      });
  }
}
